import React, { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import TalleresDisponibles from './TalleresDisponibles'
import Footer from '../../Template/Footer'
import HeroSection from './HeroSection'
import useAuthContext from '../../../hooks/useAuthContext'
import { FiArrowRight } from 'react-icons/fi'

const irA = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' })

function Home() {
    const { isSignedIn } = useAuthContext()
    const location = useLocation()
    // `n` cambia en cada búsqueda del hero, así repetir el mismo término (después de
    // haberlo borrado abajo) vuelve a aplicarse.
    const [busqueda, setBusqueda] = useState({ q: '', n: 0 })
    const [resumen, setResumen] = useState(null)

    // Llegar desde otra página con /#seccion (links del navbar). Se espera a que el
    // listado cargue: antes de eso la página es más corta y el scroll queda a medias.
    const listadoListo = resumen !== null
    useEffect(() => {
        if (!location.hash || !listadoListo) return
        const t = setTimeout(() => irA(location.hash.slice(1)), 50)
        return () => clearTimeout(t)
    }, [location.hash, listadoListo])

    const buscar = (q) => {
        setBusqueda(b => ({ q, n: b.n + 1 }))
        irA('talleres-section')
    }

    return (
        <div className="flex flex-col">
            <HeroSection onBuscar={buscar} resumen={resumen} />

            {/* Talleres section */}
            <div id="talleres-section" className="flex-1 max-w-screen-xl mx-auto w-full px-4 sm:px-6 py-8 scroll-mt-16">
                <TalleresDisponibles busqueda={busqueda} onResumen={setResumen} />
            </div>

            {/* Tarjeta Vecino Banner */}
            <div id="tarjeta-vecino" className="max-w-screen-xl mx-auto w-full px-4 sm:px-6 pb-12 scroll-mt-20">
                <div className="relative rounded-3xl overflow-hidden" style={{ background: 'linear-gradient(135deg,#00266b 0%,#003a94 50%,#0047bb 100%)' }}>
                    {/* dot pattern */}
                    <div className="absolute inset-0 opacity-10" style={{
                        backgroundImage: 'radial-gradient(circle, #ffffff 1px, transparent 1px)',
                        backgroundSize: '24px 24px'
                    }} />
                    <div className="relative z-10 flex flex-col md:flex-row items-center gap-8 p-8 md:p-10">
                        <div className="flex-1">
                            <span className="inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-widest text-blue-200 mb-3">
                                <img src="https://talleres-municipales.s3.sa-east-1.amazonaws.com/iconos/tarjetavecino.png"
                                    alt="" className="w-6 h-6 rounded-full object-cover" />
                                Beneficio exclusivo
                            </span>
                            <h2 className="text-3xl font-extrabold text-white mb-3">
                                Tarjeta <span className="hl-amarillo-invertido">Vecino</span>
                            </h2>
                            <p className="text-blue-100 leading-relaxed mb-6 max-w-md">
                                Con tu <strong className="text-white">RUT Vecino</strong>, accede a precios preferenciales
                                en todos nuestros talleres deportivos. ¡Únete a la comunidad activa de Ñuñoa!
                            </p>
                            <div className="flex flex-wrap gap-3 mb-7">
                                {['Precios preferenciales', 'Acceso prioritario', 'Beneficios exclusivos'].map(b => (
                                    <span key={b} className="inline-flex items-center gap-1.5 text-sm font-semibold text-white bg-white/15 px-3 py-1.5 rounded-full border border-white/20">
                                        ✓ {b}
                                    </span>
                                ))}
                            </div>
                            <div className="flex flex-wrap gap-3">
                                {!isSignedIn && (
                                    <Link to="/registro"
                                        className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-white text-primary font-bold text-sm hover:bg-blue-50 transition-colors">
                                        Crear mi cuenta <FiArrowRight size={15} />
                                    </Link>
                                )}
                                <button type="button" onClick={() => irA('talleres-section')}
                                    className={isSignedIn
                                        ? 'inline-flex items-center gap-2 px-6 py-3 rounded-full bg-white text-primary font-bold text-sm hover:bg-blue-50 transition-colors'
                                        : 'inline-flex items-center gap-2 px-6 py-3 rounded-full border border-white/40 text-white font-semibold text-sm hover:bg-white/10 transition-colors'}>
                                    Ver talleres {isSignedIn && <FiArrowRight size={15} />}
                                </button>
                            </div>
                        </div>
                        <div className="flex-shrink-0">
                            <img
                                src="https://talleres-municipales.s3.sa-east-1.amazonaws.com/imagenes_sitio_talleres/personas-haciendo-ejercicio-en-el-gimnasio+1.webp"
                                alt="Personas entrenando en un gimnasio"
                                className="w-full max-w-xs rounded-2xl object-cover shadow-2xl"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    )
}

export default Home
